import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";
import TitleBar from "../../../../partials/content/TitleBar";
import Pagination from "../../../../partials/content/Pagination";

function AllBanner() {
  const [allAdvertiseBannerUsers, setAllAdvertiseBannerUsers] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);

  useEffect(() => {
    getAllAdvertiseBannerUsers();
  }, []);

  useEffect(() => {
    getAllAdvertiseBannerUsers();
  }, [currentPage, countItemPerPage]);

  const getAllAdvertiseBannerUsers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allAdvertiseBannerUsers =
      await sendRequestGetAllAdvertiseBannerUsers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allAdvertiseBannerUsers) {
      return;
    }

    setAllAdvertiseBannerUsers(allAdvertiseBannerUsers.advertises);
    setCountPage(allAdvertiseBannerUsers.count_page);
  };

  const generateDoesNotHaveAnyAdvertiseTag = () => {
    return (
      <>
        <div class="d-flex flex-column flex-md-row">
          <div class="text-center text-md-right">
            <img src="/assets/img/do-not-have-advertise.svg" />
          </div>
          <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p className="text-justify">شما در حال حاضر تبلغی ندارید.</p>
            <p className="text-justify">
              تبلیغ یک طرح گرافیکی ثابت و یا متحرک از آنچه جهت نمایش به مخاطبان
              در ذهن دارید میباشد.
            </p>
          </div>
        </div>
      </>
    );
  };

  const generateConfirmTag = (confirm) => {
    let classNameConfirmAdvertise;
    let textConfirmAdvertise;
    switch (confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    return [classNameConfirmAdvertise, textConfirmAdvertise];
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllAdvertiseBannerUsers = () => {
    return (
      <div>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                تبلیغات شما توسط طراحان و گرافیست های حرفه ای و با توجه به
                استراتژی , هدف و محتوا کمپین تبلیغاتی شما آماده و در زمان مناسب
                به نمایش در می آید.
              </p>
            </li>
            <li>
              <p className="text-justify">
                شما میتوانید از قسمت عملیات فایل های تبلیغات خود را در هفت
                اندازه دریافت کنید.
              </p>
            </li>
          </ul>
        </div>

        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره تبلیغ</td>
                <td>شماره کمپین</td>
                <td>نام کمپین</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>آدرس فرود</td>
                <td>وضعیت</td>
                <td>بررسی</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allAdvertiseBannerUsers.map((advertiseBannerUser, index) => {
                let classNameStateAdvertise = advertiseBannerUser.active
                  ? "success"
                  : "danger";
                let textStateAdvertise = advertiseBannerUser.active
                  ? "فعال"
                  : "غیر فعال";
                const [classNameConfirmAdvertise, textConfirmAdvertise] =
                  generateConfirmTag(advertiseBannerUser.confirm);

                return (
                  <tr key={index}>
                    <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                    <td>
                      {helpersNumbers.toPersianNum(advertiseBannerUser.id)}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.campaign_id
                      )}
                    </td>

                    <td>{advertiseBannerUser.campaign_name}</td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.created_at
                      )}
                    </td>
                    <td>
                      {helpersNumbers.toPersianNum(
                        advertiseBannerUser.updated_at
                      )}
                    </td>
                    <td className=" text-center">
                      <a
                        className="btn btn-primary text-center"
                        target="_blank"
                        href={advertiseBannerUser.link}
                      >
                        <i className="fa fa-globe"></i>
                      </a>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameStateAdvertise} `}
                        >
                          {textStateAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div className="text-center">
                        <span
                          className={`badge badge-${classNameConfirmAdvertise}`}
                        >
                          {textConfirmAdvertise}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div>
                        <span className="pl-2">
                          <Link
                            to={`/advertise/customer/banner/view/${advertiseBannerUser.id} `}
                            className="btn btn-info  "
                          >
                            <i className="fa fa-info"></i>
                          </Link>
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </div>
    );
  };

  const sendRequestGetAllAdvertiseBannerUsers = async () => {
    const headersRequest = getHeaderForRequest();
    let allAdvertiseBannerUsers;
    try {
      allAdvertiseBannerUsers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/advertise/banner?page=${currentPage}&number=${countItemPerPage}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return allAdvertiseBannerUsers.data.data;
  };

  const sendRequestGetAllCampaignBanner = async () => {
    const headersRequest = getHeaderForRequest();
    let allCampaignBanner;
    try {
      allCampaignBanner = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/campaign/banner/simple/advertise",
        headersRequest
      );
    } catch (error) {
      return false;
    }
    return allCampaignBanner.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar
        openItem="all-advertise-customer"
        activeItem="all-advertise-banner-customer"
      />

      <div className="content-wrapper">
        <TitleBar title="تبلیغات بنری" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <div>
                {allAdvertiseBannerUsers.length == 0
                  ? generateDoesNotHaveAnyAdvertiseTag()
                  : generateAllAdvertiseBannerUsers()}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default AllBanner;
